import { forwardRef } from 'react';
import logoBlue from '../../assets/images/logo.png';
import logoWhite from '../../assets/images/logo-white.png';

// merchQRy brand mark. Two prerendered variants of the same artwork:
//   - "blue"  for light surfaces (white cards, the landing navbar)
//   - "white" for the brand-blue surfaces (AppBar, avatar badges)
// Pick the variant by the background it sits on.
export const LOGO_BRAND_COLOR = '#667eea';

const Logo = forwardRef(function Logo(
  { size = 32, variant = 'blue', alt = 'merchQRy', style, ...props },
  ref,
) {
  return (
    <img
      ref={ref}
      src={variant === 'white' ? logoWhite : logoBlue}
      width={size}
      height={size}
      alt={alt}
      data-testid="LogoIcon"
      style={{ display: 'block', objectFit: 'contain', ...style }}
      {...props}
    />
  );
});

export default Logo;
